const advanced_search_settings = require('../../../web/knowx/advanced_search_settings.json');

$('#search_save').on('click', function () {
    $('#mymodal').modal('show');
});

$('#save_query').click(function(){
    $('#mymodal').modal('hide');
    let query_name = $('#id_query_name').val();
    $('#short_search_form, #advanced_search_form').attr('action', "?save_to="+query_name).submit();
});


// Basic search
const search_form = $('#short_search_form');

search_form.find('input[name="reporting_name"]').autocomplete({
    delimiter: ';',
    onSelect: function (suggestion) {
        this.focus();
    }
});
search_form.find('input[name="reporting_type"]').autocomplete({
    delimiter: ';',
    minChars: 0
});
search_form.find('input[name="reporting_country"]').autocomplete({
    delimiter: ';',
    minChars: 0,
    lookupLimit: 10,
    onSelect: function (suggestion) {
        this.focus();
    }
});
search_form.find('input[name="active_ingredients"]').autocomplete({
    delimiter: ';',
    minChars: 1,
    onSelect: function (suggestion) {
        this.focus();
    }
});
search_form.find('input[name="therapeutic_class"]').autocomplete({
    delimiter: ';',
    minChars: 0,
    onSelect: function (suggestion) {
        this.focus();
    }
});
search_form.find('input[name="product_type"]').autocomplete({
    delimiter: ';',
    minChars: 0,
    onSelect: function (suggestion) {
        this.focus();
    }
});
search_form.find('input[name="product_dosage"]').autocomplete({
    delimiter: ';',
    minChars: 0,
    onSelect: function (suggestion) {
        this.focus();
    }
});

search_form.find('input[name="product_legal_status"]').autocomplete({
    delimiter: ';',
    minChars: 0,
    onSelect: function (suggestion) {
        $(this).focus();
    }
});

search_form.find('input[name="assessment_ion_mode"]').autocomplete({
    delimiter: ';',
    minChars: 0
});

search_form.find('input[name="origin_who"]').autocomplete({
    delimiter: ';',
    minChars: 0,
    onSelect: function (suggestion) {
        this.focus();
    }
});

search_form.find('input[name="origin_where"]').autocomplete({
    delimiter: ';',
    minChars: 0,
    onSelect: function (suggestion) {
        this.focus();
    }
});
search_form.find('input[name="criminal_phenomenon"]').autocomplete({
    delimiter: ';',
    minChars: 0,
    onSelect: function (suggestion) {
        this.focus();
    }
});
search_form.find('input[name="assessment_summary_case"]').autocomplete({
    delimiter: ';',
    minChars: 0,
    onSelect: function (suggestion) {
        this.focus();
    }
});

search_form.find('input[name="assessment_name_substance"]').autocomplete({
    delimiter: ';',
    minChars: 1,
    onSelect: function (suggestion) {
        this.focus();
    }
});

$('.datepicker').datepicker();
$('#collapseAdditionalFields').on('hide.bs.collapse', function () {
    $('.additional-fields i').removeClass('glyphicon-triangle-bottom').addClass('glyphicon-triangle-right')
});
$('#collapseAdditionalFields').on('show.bs.collapse', function () {
    $('.additional-fields i').removeClass('glyphicon-triangle-right').addClass('glyphicon-triangle-bottom')
});
$('#myDropdown').on('show.bs.dropdown', function () {
  console.log('Hello');
});

$("#short_search_form :input[type=text]").addClear({
    symbolClass: "glyphicon glyphicon-remove-circle",
    showOnLoad: true,
    clearOnEscape: true,
    returnFocus: false,
});

// Advanced search
let current_dict = {};

$('.advanced-search-formset').formset({
    prefix: 'search',
    formCssClass: 'advanced-search-formset',
    addText: 'Add criteria',
    deleteText: 'Remove',
    minForms: -1,
    added: function (row) {
        let $el = row.find('.Field')
        get_operators_for_field($el)
        let field_value = $el.val()
        //initialize change event field
        init_event_field(row, field_value)
        // initialize first suggestion
        init_suggestion(row, field_value)

    }
});


function init_suggestion(row, field_value) {
    row.find('.Value').autocomplete(
        {
            serviceUrl: $('#advanced_search_form').attr('data-service-url'),
            autoSelectFirst: false,
            minChars: 0,
            params: {field: field_value, widget: current_dict['widget']}
        });
}

function get_operators_for_field($el) {
    $.ajax({
        url: $('#advanced_search_form').attr('data-operators-url') + "?field=" + $el.val() + "&sender=" + $el[0].name,
        method: 'GET',
        dataType: 'json',
        success: function (data, textStatus) {
            let $select_op = $('select[name="' + data.item.replace("field", "operator") + '"]');
            $select_op.empty()
            for (let i in data.operators) {
                $select_op.append($('<option />').text(data.operators[i][1]).val(data.operators[i][0]));
            }
        }
    });
}

function clearErrors($id, forField) {
  let _id = $id.replace('field', forField)
  let id_div = 'div_' + _id
  let id_error = 'error_1_' + _id
  $('#' + id_div).removeClass('has-error')
  $('#' + id_error).remove()
  $('#' + _id).removeClass('form-control-danger')
}

$(document).ready(function () {
    $('select.Field').each(function () {
      // build the selectors for the second_value
      let id_operator = $(this).attr('id').replace('field', 'operator')
      let id_second_value = $(this).attr('id').replace('field', 'second_value')
      let id_second_value_div = 'div_' + id_second_value

      // check if we show second value or not
      if ($('#' + id_operator).val() == 'range')
        $('#' + id_second_value_div).show()
      else
        $('#' + id_second_value_div).hide()

      init_event_field($(this).parent().parent().parent().parent(), $(this).val());
      init_suggestion($(this).parent().parent().parent().parent(), $(this).val());
      init_event_operator($(this).parent().parent().parent().parent())
    });

    $(document).on('change', 'select.Field', function (event) {
      init_event_field($(this).parent().parent().parent().parent(), $(this).val());
      init_suggestion($(this).parent().parent().parent().parent(), $(this).val());
      get_operators_for_field($(this))

      // clear errors for first_value or second_value fields when we are switching between choices of field
      clearErrors($(this).attr('id'), 'first_value')
      clearErrors($(this).attr('id'), 'second_value')

      // build the selectors for the second_value
      let id_second_value = $(this).attr('id').replace('field', 'second_value')
      let id_second_value_div = 'div_' + id_second_value

      $('#' + id_second_value_div).hide()
    })
});

function init_event_field(row, field_value) {
    GetWidget_Operator(row, field_value)
    checkInputWidget(current_dict['widget'], row)
    row.find('.Field').change(function (e) {
        let field_value = $(this).val()
        GetWidget_Operator(row, $(this).val())
        checkInputWidget(current_dict['widget'], row)
        init_suggestion(row, field_value)
    });
}

function Disable_Value(row, operator_value) {
    if (operator_value == 'isnull')
        row.find('.Value').prop('disabled', true);
    else
        row.find('.Value').prop('disabled', false);
}

function init_event_operator(row) {
    row.find('.Operator').change(function () {
        Hide_Second_Value($(this).parent().parent().parent().parent(), $(this).val())
        Disable_Value($(this).parent().parent().parent().parent(), $(this).val())
    });
}

function GetWidget_Operator(row, value) {
    current_dict['widget'] = advanced_search_settings['fields']
    for(let field of advanced_search_settings['fields']) {
        if(field.field == value) {
            current_dict['widget'] = field.widget;
            current_dict['operator'] = field.operator;
        }
    }
}

function checkInputWidget(widget, row) {
    let class_to_remove = ''
    let class_to_add = ''
    let type = ''

    if (widget == 'TextInput' || widget == 'Select' || widget == 'EmailInput') {
        type = 'text'
        class_to_remove = 'numberinput dateinput'
        class_to_add = 'textinput'
        genric_change_widget(type, class_to_remove, class_to_add, row)
        DisableDatePicker(row)
    }
    else if (widget == 'NumberInput') {
        type = 'number'
        class_to_remove = 'textinput textInput dateinput'
        class_to_add = 'numberinput'
        genric_change_widget(type, class_to_remove, class_to_add, row)
        DisableDatePicker(row)
    }
    else if (widget == 'DateInput') {
        type = 'text'
        class_to_remove = 'textinput textInput numberinput'
        class_to_add = 'dateinput'
        genric_change_widget(type, class_to_remove, class_to_add, row)
    }
}


function Hide_Second_Value(row, operator_value) {
    if (operator_value == 'range')
        row.find('.SecondValue').parent().parent().show()
    else
        row.find('.SecondValue').parent().parent().hide()
}

function genric_change_widget(type, class_to_remove, class_to_add, row) {
    row.find('.Value').prop("type", type);
    row.find('.Value').removeClass(class_to_remove);
    row.find('.Value').addClass(class_to_add);
    $('.dateinput').datepicker();
}

function DisableDatePicker(row) {
    row.find('.Value').datepicker("destroy");
    row.find('.Value').removeClass("hasDatepicker");
}

$('#id_active_ingredients_labelled ' +
  '#id_active_ingredients_identified ' +
  '#id_therapeutic_class_labelled ' +
  '#id_therapeutic_class_identified').tooltip()
